import React from 'react'
import { withRouter } from 'react-router-dom'
import iconEdit from '../../../../assets/icons/edit-black.svg'
import iconDelete from '../../../../assets/icons/delete-black.svg'
import './article.styles.scss'
import Loading from '../../../../components/loading/loading.component'
import Worker from './worker'

class Article extends React.Component {

    constructor(){
        super()
        this.worker = Worker(this)
        this.state = this.worker.getDefaultState()
    }

    onDelete = () => this.worker.deleteArticle()

    render(){
        return (
            <div className="article">
                <div>
                    <h4>{this.props.title}</h4>
                    <p>Number: {this.props.number}</p>
                    <p>Archive: {this.props.archive.journal.url.toUpperCase()} {this.props.archive.year}/{this.props.archive.month}/{this.props.archive.volume}/{this.props.archive.issue}</p>
                    <p>Article Type: {this.props.articleType.name}</p>
                    <p>Pages: {this.props.pageStart} - {this.props.pageEnd}</p>
                    <p>DOI: {this.props.doi}</p>
                    <p>Publication Date: {new Date(this.props.publicationDate).toString("dd MMM, yyyy")}</p>
                </div>
                <div>
                    <img alt="" src={iconEdit} onClick={() => this.props.history.push('/article/articles/edit/' + this.props.id)} />
                    {
                        this.state.deleting ? <Loading /> : <img alt="" src={iconDelete} onClick={this.onDelete} />
                    }
                </div>
            </div>
        )
    }
}

export default withRouter(Article)